import { Link } from 'react-router-dom';
import { editorPicks } from '@/mocks/data';

export default function EditorPickSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <span className="w-1 h-6 md:h-8 bg-primary-500 rounded-full"></span>
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950">
            编辑<strong>精选</strong>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {editorPicks.map((pick) => (
            <article
              key={pick.id}
              className="bg-foreground-950 rounded-lg p-6 md:p-8 relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 text-8xl md:text-9xl text-primary-500/10 font-heading leading-none select-none">
                "
              </div>
              <div className="relative z-10">
                <div className="flex items-center gap-2 mb-4">
                  <span className="px-2.5 py-0.5 bg-primary-500/20 text-primary-400 text-xs rounded-full font-medium">
                    {pick.rating}分
                  </span>
                  <span className="text-xs text-foreground-500">{pick.title}</span>
                </div>
                <p className="text-sm md:text-base text-background-100 leading-relaxed mb-5">
                  {pick.comment}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">—— {pick.editor}</span>
                  <Link
                    to={`/article/${pick.id}`}
                    className="px-4 py-1.5 bg-accent-100/15 text-accent-400 rounded-full text-xs hover:bg-accent-100/25 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    去看看
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}